import { styled } from '@mui/material/styles';
import { ArrowDownIcon } from 'assets/images/icons';

export const StyledArrowRight = styled(ArrowDownIcon)({
    transform: 'rotate(270deg)',
    width: 6,
    height: 4,
    marginLeft: 'auto',
});

export const StyledMenuHeader = styled('div')({
    fontFamily: 'Rubik',
    fontWeight: 500,
    fontSize: '10px',
    lineHeight: '12px',
    letterSpacing: '1.5px',
    color: 'rgba(0, 0, 0, 0.38)',
    textTransform: 'uppercase',
    padding: '0 16px',
    marginBottom: 8,
    marginTop: 6,
});

export const ScrollableSection = styled('div')({
    width: '100%',
    overflowY: 'auto',
    maxHeight: 320,
    '@media (max-width: 600px)': {
        maxHeight: '160px',
        overflowY: 'auto',
    },
});
